import { Paginator } from "primereact/paginator";
import React, { useEffect, useState } from "react";
import CourseItem from "./CourseItem";
import { getCoursesData } from "../services/courseService";

export default function CourseList({ style, searchString, tabString }) {
  const [rows, setRows] = useState(10);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(Math.ceil(200 / rows));
  const [first, setFirst] = useState(0);
  const [coursesData, setCoursesData] = useState([]);

  const onPageChange = (event) => {
    setPage(event.page + 1);
    setTotalPages(Math.ceil(200 / event.rows));
    setFirst(event.first);
    setRows(event.rows);
  };

  const leftContentPaginator = (
    <p className="gray-color mr-2" style={{ transform: "translateY(-2px)" }}>
      Hiển thị {page} trong số {totalPages} trang với 200 kết quả
    </p>
  );

  const paginatorTemplate = {
    layout:
      "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
    FirstPageLink: (options) => {
      return (
        <button
          type="button"
          className={options.className}
          style={{
            border: "1px solid #E2E8F0",
            margin: 0,
            borderRight: "none",
            borderRadius: 0,
            borderTopLeftRadius: "2px",
            borderBottomLeftRadius: "2px",
          }}
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <i className="pi pi-angle-double-left"></i>
        </button>
      );
    },
    PrevPageLink: (options) => {
      return (
        <button
          type="button"
          className={options.className}
          style={{
            border: "1px solid #E2E8F0",
            margin: 0,
            borderRight: "none",
            borderRadius: 0,
          }}
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <i className="pi pi-angle-left"></i>
        </button>
      );
    },
    PageLinks: (options) => {
      return (
        <button
          type="button"
          className={options.className}
          style={{
            border: "1px solid #E2E8F0",
            margin: 0,
            borderRight: "none",
            borderRadius: 0,
          }}
          onClick={options.onClick}
        >
          {options.page + 1}
        </button>
      );
    },
    NextPageLink: (options) => {
      return (
        <button
          type="button"
          className={options.className}
          style={{
            border: "1px solid #E2E8F0",
            margin: 0,
            borderRight: "none",
            borderRadius: 0,
          }}
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <i className="pi pi-angle-right"></i>
        </button>
      );
    },
    LastPageLink: (options) => {
      return (
        <button
          type="button"
          className={options.className}
          style={{
            border: "1px solid #E2E8F0",
            margin: 0,
            borderRadius: 0,
            borderTopRightRadius: "2px",
            borderBottomRightRadius: "2px",
          }}
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <i className="pi pi-angle-double-right"></i>
        </button>
      );
    },
  };

  const fetchCoursesData = async () => {
    const queryParams = {};
    queryParams.page = page;
    queryParams.limit = rows;
    if (searchString?.length) {
      queryParams.search = searchString;
    }
    if (tabString?.length) {
      queryParams.tabs = tabString;
    }
    const data = await getCoursesData(queryParams);
    setCoursesData(data);
  };

  useEffect(() => {
    fetchCoursesData();
  }, [searchString, tabString, page, rows]);

  return (
    <div className="course-list-component" style={style}>
      <div className="course-list-wrapper">
        {coursesData.map((course, index) => (
          <div key={index} className="course-list-wrapper-item">
            <CourseItem key={course?.id} courseData={course} />
          </div>
        ))}
      </div>
      <div className="course-list-pagination">
        <Paginator
          template={paginatorTemplate}
          first={first}
          rows={rows}
          totalRecords={200}
          rowsPerPageOptions={[5, 10, 20, 30]}
          onPageChange={onPageChange}
          leftContent={leftContentPaginator}
        />
      </div>
    </div>
  );
}
